import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BrandLockup } from "../components/app/Logo";
import { BackButton } from "../components/app/BackButton";
import { useI18n } from "../lib/i18n";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";
import { useState } from "react";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch { /* always succeed silently */ }
    setSent(true);
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="forgot-page">
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-8 h-14 flex items-center justify-between">
          <Link to="/"><BrandLockup /></Link>
          <BackButton fallback="/login" />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md surface-card p-8">
          <span className="label-mono">PASSWORD // RESET</span>
          <h1 className="mt-3 text-2xl font-semibold tracking-tight">{t("forgot_title")}</h1>
          <p className="mt-2 text-sm text-neutral-400">{t("forgot_desc")}</p>

          {sent ? (
            <p className="mt-8 text-sm text-bull font-mono" data-testid="forgot-sent">{t("forgot_sent")}</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-2">
                <Label className="label-mono">{t("field_email")}</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="bg-[#0e0e0e] border-white/10 rounded-none h-11 font-mono focus-visible:ring-bull/40 focus-visible:border-bull/40"
                  data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={busy} className="w-full rounded-none bg-white text-black hover:bg-neutral-200 h-11 font-medium" data-testid="forgot-submit-btn">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : t("forgot_submit")}
              </Button>
            </form>
          )}

          <Link to="/login" className="mt-6 inline-block font-mono text-xs text-neutral-500 hover:text-bull">← {t("nav_login")}</Link>
        </div>
      </div>
    </div>
  );
}
